import * as React from "react";

interface OpenAiMessageBarProps {
  role: OpenAiRole;
  name?: string;
  imageSrc?: string;
  content: React.ReactNode;
  disabled?: boolean;
}

export default function DocOpenAiMessageBar(props: OpenAiMessageBarProps) {
  const {
    role,
    name,
    imageSrc,
    content,
    disabled,
  } = props;

  const renderedData = [
    <div key="messageName">
      <div style={{backgroundColor: role === "user" ? "#0570C7" : "#FC8181" }} className={`h-20 w-20 rounded-full flex justify-center items-center overflow-hidden ${disabled ? "opacity-70" : ""}`}>
        {imageSrc ? <img src={imageSrc} className="min-w-full min-h-full w-auto" /> : <span className="self-center text-center flex-1 text-white"><strong>{name || role}</strong></span>}
      </div>
    </div>,
    <div key="message" style={{backgroundColor: role === "user" ? "#DAEEFF" : "#eee" }} className="message-bar-messages flex-1 p-3 rounded-lg self-center">
      {content}
    </div>,
  ];

  if (role === "user") { renderedData.reverse(); }

  return (
    <div className="flex gap-x-2 mb-3">
      {renderedData}
    </div>
  );
}
